import React, { useState } from "react";
import classes from "./Tabs.module.css";
import clsx from "clsx";

const Tabs = ({ tabs, activeTab, setActiveTab, className, sm, v2 }) => {
  return (
    <div
      className={clsx(
        classes.tabs,
        className,
        sm && classes.sm,
        v2 && classes.v2
      )}
    >
      {tabs.map((tab, i) => (
        <button
          className={clsx(classes.tab, activeTab === tab && classes.activeTab)}
          key={i}
          onClick={() => setActiveTab(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
